

const LegalDocumentFilters = ({ filters, onFilterChange }) => {
  const categoryOptions = [
    { value: "", label: "All Categories" },
    { value: "terms_conditions", label: "Terms & Conditions" },
    { value: "privacy_policy", label: "Privacy Policy" },
    { value: "disclaimer", label: "Disclaimer" },
    { value: "ip_management", label: "IP Management" },
    { value: "cookie_policy", label: "Cookie Policy" },
    { value: "refund_policy", label: "Refund Policy" },
    { value: "community_guidelines", label: "Community Guidelines" },
    { value: "seller_agreement", label: "Seller Agreement" },
    { value: "buyer_agreement", label: "Buyer Agreement" },
    { value: "api_terms", label: "API Terms" },
  ]

  const typeOptions = [
    { value: "", label: "All Types" },
    { value: "rich_text", label: "Rich Text" },
    { value: "markdown", label: "Markdown" },
    { value: "html", label: "HTML" },
    { value: "static", label: "Static" },
    { value: "custom_upload", label: "File Upload" },
  ]

  const statusOptions = [
    { value: "", label: "All Status" },
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
  ]

  const handleFilterChange = (key, value) => {
    onFilterChange({ [key]: value })
  }

  const handleSearchChange = (e) => {
    const value = e.target.value
    // Debounce search
    clearTimeout(window.searchTimeout)
    window.searchTimeout = setTimeout(() => {
      onFilterChange({ search: value })
    }, 500)
  }

  const clearFilters = () => {
    onFilterChange({
      category: "",
      type: "",
      isActive: "",
      search: "",
    })
  }

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="row align-items-end">
          <div className="col-md-3">
            <label className="form-label">Search</label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="fas fa-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search documents..."
                defaultValue={filters.search}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div className="col-md-2">
            <label className="form-label">Category</label>
            <select
              className="form-select"
              value={filters.category}
              onChange={(e) => handleFilterChange("category", e.target.value)}
            >
              {categoryOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">Type</label>
            <select
              className="form-select"
              value={filters.type}
              onChange={(e) => handleFilterChange("type", e.target.value)}
            >
              {typeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={filters.isActive}
              onChange={(e) => handleFilterChange("isActive", e.target.value)}
            >
              {statusOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label">Items per page</label>
            <select
              className="form-select"
              value={filters.limit}
              onChange={(e) => handleFilterChange("limit", e.target.value)}
            >
              <option value="12">12</option>
              <option value="24">24</option>
              <option value="48">48</option>
              <option value="96">96</option>
            </select>
          </div>

          <div className="col-md-1">
            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={clearFilters}
              title="Clear Filters"
            >
              Clear
            </button>
          </div>
        </div>

        {/* Active Filters Display */}
        {(filters.category || filters.type || filters.isActive || filters.search) && (
          <div className="mt-3">
            <small className="text-muted">Active filters:</small>
            <div className="d-flex flex-wrap gap-2 mt-1">
              {filters.search && (
                <span className="badge bg-primary">
                  Search: "{filters.search}"
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("search", "")}
                  ></button>
                </span>
              )}
              {filters.category && (
                <span className="badge bg-info">
                  Category: {categoryOptions.find((o) => o.value === filters.category)?.label}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("category", "")}
                  ></button>
                </span>
              )}
              {filters.type && (
                <span className="badge bg-success">
                  Type: {typeOptions.find((o) => o.value === filters.type)?.label}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("type", "")}
                  ></button>
                </span>
              )}
              {filters.isActive && (
                <span className="badge bg-warning">
                  Status: {statusOptions.find((o) => o.value === filters.isActive)?.label}
                  <button
                    type="button"
                    className="btn-close btn-close-white ms-1"
                    style={{ fontSize: "0.7em" }}
                    onClick={() => handleFilterChange("isActive", "")}
                  ></button>
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default LegalDocumentFilters
